<template>

  <div>
    <div style="width: 100%;">
      <img src="../../productAndService/banner_01.png" alt="产品与服务" style="width: 100%; height: auto;">
    </div>

    <!-- 头部切换 -->
    <div class="wd100 pdtop" style="width: 1255px;margin: 40px auto;position: relative;">
      <div class="breadcrumb">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb-list">
            <li class="breadcrumb-item"><a @click="active('/')">首页></a></li>
            <li class="breadcrumb-item"><a href="#">产品与服务></a></li>
            <li class="breadcrumb-item">财务审计</li>
          </ol>
        </nav>
      </div>
      <div class="navigation">
        <div class="navigation-title">财务审计</div>
        <div class="navigation-link-2s" style="line-height: 2">
          <a style="margin-left: 120px" href="#" class="navigation-link-2" :class="{ active: activeLink === 'patent' }"
             @click.prevent="selectLink('patent')">财务审计报告</a>
<!--          <span class="separator">|</span>-->
<!--          <a href="#" class="navigation-link-2" :class="{ active: activeLink === '2'  }"-->
<!--             @click.prevent="selectLink('2')">资产评估报告</a>-->
<!--          <span class="separator">|</span>-->
<!--          <a href="#" class="navigation-link-2" :class="{ active: activeLink === '3' }"-->
<!--             @click.prevent="selectLink('3')">高新专项审计</a>-->
<!--                    <span class="separator">|</span>-->
<!--                    <a href="#" class="navigation-link-2" :class="{ active: activeLink === '4' }" @click.prevent="selectLink('4')">双软认定专项审计</a>-->
          <span class="separator">|</span>
          <a href="#" class="navigation-link-2" :class="{ active: activeLink === 'trademark' }" @click.prevent="selectLink('trademark')">公司注册</a>
<!--          <br>-->
          <span class="separator">|</span>
          <a href="#" class="navigation-link-2" :class="{ active: activeLink === 'copyright' }" @click.prevent="selectLink('copyright')">记账报税</a>
<!--          <span class="separator">|</span>-->
<!--          <a href="#" class="navigation-link-2" :class="{ active: activeLink === '5' }" @click.prevent="selectLink('5')">信息化咨询</a>-->
<!--          <span class="separator">|</span>-->
<!--          <a href="#" class="navigation-link-2" :class="{ active: activeLink === '6' }" @click.prevent="selectLink('6')">税务疑难</a>-->
<!--          <span class="separator">|</span>-->
<!--          <a href="#" class="navigation-link-2" :class="{ active: activeLink === '7' }" @click.prevent="selectLink('7')">审计年报</a>-->
<!--          <span class="separator">|</span>-->
<!--          <a href="#" class="navigation-link-2" :class="{ active: activeLink === '8' }" @click.prevent="selectLink('8')">审计评估</a>-->

        </div>
        <div class="navigation-link-2s">

        </div>
      </div>
    </div>


    <!--财务审计报告start******************************************************************************************************************************************************************************-->
    <div v-show="patentShow">
      <div class="wd100 pdtop pdtopStyle" style="height: 1500px">
        <!--申报条件-->
        <div style="position: absolute;margin-top: 20px;">
          <span class="titleSty">税务审计报告介绍
          <span class="spanSty">Introduce</span></span>
        </div>
        <div style="position: absolute; margin-top: 80px;width: 1215px">
           <p class="pstyle2">
             &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;税务审计报告是税务审计人员根据税务审计的相关法律、法规,对被审计单位的纳税行为和纳税事项进行评估，并发表意见的书面文件。安贝森拥有从业五年以上资深会
           计师团队，熟悉各行业各地工商税务政策，为您做好合理纳税筹划，并提供整体财税解决方案。安贝森可为您提供代理记账，税务审计，风险评估，疑难税务账务处理。
           </p>
        </div>

        <!--税务审计报告的主要作用-->
        <div style="position: absolute;margin-top: 190px;">
          <span class="titleSty">税务审计报告的主要作用
          <span class="spanSty">Majorrole</span></span>
        </div>
        <div style="position: absolute; margin-top: 240px;width: 1215px">
          <div class="custom-service-container">
            <div class="service-unit">
              <img src="./sjbg01.png" alt="服务项目1" class="service-image">
              <div class="overlay-content">
                <span class="circle-number">1</span>
                <p class="service-description">可减少税务检查风险；</p>
              </div>
            </div>
            <div class="service-unit">
              <img src="./sjbg01.png" alt="服务项目2" class="service-image">
              <div class="overlay-content">
                <span class="circle-number">2</span>
                <p class="service-description">可弥补亏损，减少税款支出；</p>
              </div>
            </div>
            <div class="service-unit">
              <img src="./sjbg01.png" alt="服务项目3" class="service-image">
              <div class="overlay-content">
                <span class="circle-number">3</span>
                <p class="service-description">利用专业会计的专业能力，为企业节税；</p>
              </div>
            </div>
            <div class="service-unit">
              <img src="./sjbg01.png" alt="服务项目4" class="service-image">
              <div class="overlay-content">
                <span class="circle-number">4</span>
                <p class="service-description">提前查清企业是否偷漏税，避免受到处罚；</p>
              </div>
            </div>
            <div class="service-unit">
              <img src="./sjbg01.png" alt="服务项目5" class="service-image">
              <div class="overlay-content">
                <span class="circle-number">5</span>
                <p class="service-description">调整不恰当的会计处理，正确申报企业所得税。</p>
              </div>
            </div>
          </div>
        </div>

        <!--服务流程-->
        <div style="position: absolute;margin-top: 580px;width: 1255px">
          <span class="titleSty">服务流程
          <span class="spanSty">Service process</span></span>
        </div>
        <div style="width: 1255px;position: absolute; margin-top: 660px;">
          <div class="flowchart-container-updated">
            <img src="./gj008.png" alt="流程图背景" class="flowchart-background-updated">
            <div class="step-texts-updated">
              <div class="step-text step1-updated">专业咨询</div>
              <div class="step-text step2-updated">材料收集整理</div>
              <div class="step-text step3-updated">税务师审计初稿</div>
              <div class="step-text step4-updated">税务师审核</div>
              <div class="step-text step5-updated">出具报告</div>
              <div class="step-text step6-updated">办理完成</div>
            </div>
          </div>
        </div>

        <div style="position: absolute;margin-top: 900px;width: 707px">
          <span class="titleSty">安贝森优势
          <span class="spanSty">Our advantage</span></span>
        </div>
        <AdvantageList  customStyle="position: absolute;margin-top: 950px;width: 1200px;margin-left: -25px;" />
      </div>
    </div>
    <!--财务审计报告end******************************************************************************************************************************************************************************-->


    <!--公司注册start*******************************************************************************************************************************************************************************-->
    <div v-show="trademarkShow">
      <div class="wd100 pdtop pdtopStyle" style="height: 2220px">
        <img src="./banner001.png" alt="公司注册" style="width: 99.8%">
        <!--申报条件-->
        <div style="position: absolute;margin-top: 40px;">
          <span class="titleSty">公司注册
          <span class="spanSty">Company registration</span></span>
        </div>
        <div style="position: absolute; margin-top: 100px;width: 1215px">
          <p class="pstyle2">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;公司注册是开始创业的第一步。一般来说，公司注册的流程包括：企业核名→提交材料→领取执照→刻章，就可以完成公司注册，进行开业了。但是，公司想要正式开始
            经营，还需要办理以下事项：银行开户→税务报到→申请税控和发票→社保开户。
          </p>
        </div>


        <!--申请所需资料-->
        <div style="position: absolute;margin-top:210px;width: 1100px">
          <span class="titleSty">申请所需资料
          <span class="spanSty">Prepared materials</span>
          </span>
           <p class="pstyle2" style="margin-top: 20px">1、公司法定代表人签署的《公司设立登记申请书》；</p>
           <p class="pstyle2">2、全体股东签署的公司章程；</p>
           <p class="pstyle2">3、法人股东资格证明或者自然人股东身份证及其复印件；</p>
           <p class="pstyle2">4、董事、监事和经理的任职文件及身份证复印件；</p>
           <p class="pstyle2">5、指定代表或委托代理人证明；</p>
           <p class="pstyle2">6、代理人身份证及其复印件；</p>
           <p class="pstyle2">7、住所使用证明。</p>
           <p class="pstyle2">注：住所使用证明材料的准备，分为以下三种情况：</p>
           <p class="pstyle2">（1）若是自己房产，需要房产证复印件，自己的身份证复印件；</p>
           <p class="pstyle2">（2）若是租房，需要房东签字的房产证复印件，房东的身份证复印件，双方签字盖章的租赁合同，和租金发票；</p>
           <p class="pstyle2">（3）若是租的某个公司名下的写字楼，需要该公司加盖公章的房产证复印件，该公司营业执照复印件，双方签字盖章的租赁合同，还有租金发票。</p>
        </div>

        <!--注册流程-->
        <div style="position: absolute;margin-top: 650px;width: 1255px">
          <span class="titleSty">注册流程
          <span class="spanSty">Registration process</span></span>
        </div>
        <div style="width: 1255px;position: absolute; margin-top: 720px;">
          <div class="process-container">
            <img src="./bq003.png" alt="背景图片" class="process-background-image">

            <div class="process-text-overlay">
              <div class="process-step-1">
                <div class="process-title-vertical">核&nbsp;准&nbsp;名&nbsp;称</div>
                <p class="process-description" style="line-height: 2">确定公司类型、名字、注册资本、股东及出资比例</p>
              </div>
              <div class="process-step-1">
                <div class="process-title-vertical">提&nbsp;交&nbsp;材&nbsp;料</div>
                <p class="process-description" style="line-height: 2">确认地址信息、高管信息、经营范围，在线提交预申请
                </p>
              </div>
              <div class="process-step-1">
                <div class="process-title-vertical">领&nbsp;取&nbsp;执&nbsp;照</div>
                <p class="process-description">工商局领取营业执照正、副本</p>
              </div>
              <div class="process-step-1">
                <div class="process-title-vertical">刻&nbsp;章</div>
                <p class="process-description">到公安局指定刻章点办理</p>
              </div>
            </div>

          </div>
        </div>

        <!--服务流程-->
        <div style="position: absolute;margin-top: 890px;width: 1255px">
          <span class="titleSty">服务流程
          <span class="spanSty">Service process</span></span>
        </div>
        <div style="width: 1255px;position: absolute; margin-top: 960px;">
          <div class="flowchart-container-updated">
            <img src="./gj008.png" alt="流程图背景" class="flowchart-background-updated">
            <div class="step-texts-updated">
              <div class="step-text step1-updated">专业咨询</div>
              <div class="step-text step2-updated">材料收集整理</div>
              <div class="step-text step3-updated">税务师审计初稿</div>
              <div class="step-text step4-updated">税务师审核</div>
              <div class="step-text step5-updated">出具报告</div>
              <div class="step-text step6-updated">办理完成</div>
            </div>
          </div>
        </div>

        <div style="position: absolute;margin-top: 1190px;width: 707px">
          <span class="titleSty">安贝森优势
          <span class="spanSty">Our advantage</span></span>
        </div>
        <AdvantageList  customStyle="position: absolute;margin-top: 1240px;width: 1200px;margin-left: -25px;" />
      </div>
    </div>
    <!--公司注册end*******************************************************************************************************************************************************************************-->


    <!--记账报税******************************************************************************************************************************************************************************-->
    <div v-show="copyrightShow">
      <div class="wd100 pdtop pdtopStyle" style="height: 2220px">
        <img src="./banner002.png" alt="风险" style="width: 99.8%">
        <!--申报条件-->
        <div style="position: absolute;margin-top: 40px;">
          <span class="titleSty">记账报税
          <span class="spanSty">Bookkeeping and tax reporting</span></span>
        </div>
        <div style="position: absolute; margin-top: 100px;width: 1192px">
          <p class="pstyle2">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;记账报税是以《会计法》为准则，为各行业的企业建立全套标准的会计账簿，建立健全企业全套财务管理制度。代理记账为企业代理记账，编制各种会计报表，带税务
            申报，装订会计凭证，上门取送会计档案等全套会计工作。按照现代企业会计制度，对企业遗留的财务问题和账簿进行重新规范调整，符合税务查账的需要。
          </p>
        </div>


        <!--版权申请的好处及作用-->
        <div style="position: absolute;margin-top: 150px;width: 1255px">
          <div class="advantage-container">
            <div class="service-block">
              <img src="./dljz001.png" alt="代建新账" class="advantage-icon-gj">
              <p class="advantage-desc">代建新账</p>
            </div>
            <div class="service-block">
              <img src="./dljz002.png" alt="代理记账" class="advantage-icon-gj">
              <p class="advantage-desc">代理记账</p>
            </div>
            <div class="service-block">
              <img src="./dljz003.png" alt="清理乱账" class="advantage-icon-gj">
              <p class="advantage-desc">清理乱账</p>
            </div>
            <div class="service-block">
              <img src="./dljz004.png" alt="手工账改电子账" class="advantage-icon-gj">
              <p class="advantage-desc">手工账改电子账</p>
            </div>
            <div class="service-block">
              <img src="./dljz005.png" alt="进出口会计业务" class="advantage-icon-gj">
              <p class="advantage-desc">进出口会计业务 代理及咨询</p>
            </div>
          </div>
        </div>

        <div class="service-container" style="position: absolute;margin-top: 450px;width: 1196px;">
          <!-- 基础服务 -->
          <div class="service-column">
            <div class="content-wrapper">
              <div class="header basic-service-header">
                <img src="./dljz006.png" alt="基础服务图标" class="service-image-2">
                <h2>基础服务</h2>
                <p>企业代理记账（年付套餐）</p>
              </div>
              <ul class="services">
                <li>整理原始凭据（所有记账报税必须票据）</li>
                <li>财税专家对所有数据资料审核</li>
                <li>财税记账管理咨询建议</li>
                <li>月度或季度税务申报</li>
                <li>税务申报表及时推送、出具财务报表</li>
                <li>月度装订凭证、年末装订账簿</li>
                <li>日常基本财务记账咨询、财税风险预警</li>
              </ul>
            </div>
            <button class="details-button basic-service-button" @click="showDialog = true">详情咨询 &gt;</button>
          </div>
          <!-- 引入弹窗组件 -->
          <call-me-dialog v-if="showDialog" :visible.sync="showDialog" />
          <!-- 免费服务 -->
          <div class="service-column">
            <div class="content-wrapper">
              <div class="header free-service-header">
                <img src="./dljz007.png" alt="免费服务图标" class="service-image-2">
                <h2>免费服务</h2>
                <p>企业代理记账（年付套餐）</p>
              </div>
              <ul class="services">
                <li>企业年度所得税汇算清缴</li>
                <li>新注册公司免费赠送税务报道</li>
                <li>企业工商年检</li>
                <li>终身后续指导和免费财税咨询服务</li>
                <li>核定残保金(年付赠送)</li>
                <li>法人一证通(年付赠送)</li>
              </ul>
            </div>
            <button class="details-button free-service-button" @click="showDialog = true" style="margin-top: 85px">详情咨询 &gt;</button>
          </div>

          <!-- 资料 -->
          <div class="service-column">
            <div class="content-wrapper">
              <div class="header materials-header">
                <img src="./dljz008.png" alt="资料图标" class="service-image-2">
                <h2>资料</h2>
                <p>您需要提供的资料</p>
              </div>
              <ul class="services">
                <li>公司执照副本复印件</li>
                <li>法人、股东身份证复印件</li>
                <li>银行开户许可证复印件</li>
                <li>一证通</li>
                <li>非新注册的公司交接原会计资料</li>
              </ul>
            </div>
            <button class="details-button materials-button" @click="showDialog = true" style="margin-top: 150px">详情咨询 &gt;</button>
          </div>
        </div>

        <div style="position: absolute;margin-top: 1250px;width: 707px">
          <span class="titleSty">安贝森优势
          <span class="spanSty">Our advantage</span></span>
        </div>
        <AdvantageList  customStyle="position: absolute;margin-top: 1310px;width: 1200px;margin-left: -25px;" />
      </div>
    </div>
    <!--记账报税******************************************************************************************************************************************************************************-->

    <div class="wd100 pdtop" style="width: 1255px;margin: 0px auto;height:150px">
    </div>
  </div>


</template>
<style scoped>
@import 'financialAudit.css';
</style>
<script>
import AdvantageList from '../common/advantageList.vue';
import CallMeDialog from "../../../components/CallMeDialog.vue";

export default {
  components: {CallMeDialog, AdvantageList},
  data() {
    return {
      activeLink: 'patent',
      patentShow: true,
      trademarkShow: false,
      copyrightShow: false,
      softwareShow: false,
      showDialog: false,

    }
  },

  methods: {
    selectLink(link) {

      // 重置所有模块的显示状态为 false
      this.patentShow = false;
      this.trademarkShow = false;
      this.copyrightShow = false;
      this.softwareShow = false;

      // 根据点击的链接设置对应模块的显示状态为 true
      if (link === 'patent') {
        this.patentShow = true;
      } else if (link === 'trademark') {
        this.trademarkShow = true;
      } else if (link === 'copyright') {
        this.copyrightShow = true;
      } else if (link === 'software') {
        this.softwareShow = true;
      }

      this.activeLink = link; // 更新当前选中的链接

    },
  },
  mounted: function () {

  },
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/pages/service/financialAudit/financialAudit.vue